import React, { Fragment, useEffect, useMemo, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import "tippy.js/dist/tippy.css";
import PageHeading from "Layout/AppMain/PageHeading";
import CustomFilter from "Components/ReactTable/Filters/CustomFilters";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { Link } from "react-router-dom";
import { iconSwitch } from "../utils";
import TextLimit from "Api/TextLimit";
import { useCurrentWeekstaat, useDownloadWeekstaatReport } from "Api/Melder/WeekReport/Actueel";

const Actueel = () => {
    const [data, setData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [dropdownData, setDropdownData] = useState([]);
    const [downloadId, setDownloadId] = useState(null);

    const { data: downloadResponse } =
        useDownloadWeekstaatReport(downloadId);

    const { data: currentWeekstaatResponse } = useCurrentWeekstaat();

    const totalCount = currentWeekstaatResponse?.totalCount;
    useEffect(() => {
        const weekstaatData = currentWeekstaatResponse?.weekstaat || [];

        if (weekstaatData.length > 0) {
            const updatedWeekstaat = weekstaatData.map((item) => ({
                ...item,
                filterName: item.school,
                filterId: item.school_id,
            }));

            setData(updatedWeekstaat);
            setFilterData(updatedWeekstaat);

            const uniqueDropdownData = [
                ...new Map(
                    updatedWeekstaat.map((item) => [item.school_id, item])
                ).values(),
            ];

            setDropdownData(uniqueDropdownData);
        } else {
            setData([]);
            setFilterData([]);
            setDropdownData([]);
        }
    }, [currentWeekstaatResponse]);

    const handleSelect = (selectedValue) => {
        const updatedList = selectedValue
            ? filterData.filter((value) => value.school_id == selectedValue)
            : filterData;

        setData(updatedList);
    };

    const { data: downloadData } = useDownloadWeekstaatReport(downloadId);

    useEffect(() => {
        if (downloadData?.file?.download) {
            const link = document.createElement("a");
            link.href = downloadData.file.download;
            link.download = "weekstaat-report.pdf";
            link.click();
        }
    }, [downloadData]);

    const columns = useMemo(
        () => [
            {
                header: () => "Id",
                accessorKey: "id",
                cell: (value) => {
                    return (
                        <Link
                            to={`/weekstaat/${value.row.original.id}`}
                            key={value.row.original.id}
                            state={{
                                wsId: value.row.original.id,
                                wid: value.row.original.wid,
                                schoolId: value.row.original.school_id,
                            }}
                        >
                            {value.row.original.id}
                        </Link>
                    );
                },
            },
            {
                header: () => "Organisatie",
                accessorKey: "organization",
                cell: (value) => {
                    return window.innerWidth > 1250
                        ? TextLimit.limitStringLargeScreen(
                            value.row.original.organization
                        )
                        : TextLimit.limitStringSmallScreen(
                            value.row.original.organization
                        );
                },
            },
            {
                header: () => "School",
                accessorKey: "school",
                cell: (value) => {
                    return window.innerWidth > 1250
                        ? TextLimit.limitStringLargeScreen(value.row.original.school)
                        : TextLimit.limitStringSmallScreen(value.row.original.school);
                },
            },
            {
                header: () => "Begindatum",
                accessorKey: "start_date",
            },
            {
                header: () => "Einddatum",
                accessorKey: "end_date",
            },
            {
                header: () => "Datum/tijd weekstaat",
                accessorKey: "created",
            },
            {
                header: () => "Status",
                accessorKey: "status",
                cell: (value) => iconSwitch(value.row.original.status),
            },
            {
                header: () => "Actie",
                accessorKey: "pdf",
                cell: (value) =>
                    value.row.original.filename !== null ? (
                        <a
                            href="javascript:void(0)"
                            onClick={() => setDownloadId(value.row.original.id)}
                            className="anchor-action-link"
                        >
                            <div className="font-icon-wrapper download-button-style">
                                <i className="pe-7s-download btn-icon-wrapper icon"> </i>
                            </div>
                        </a>
                    ) : (
                        ""
                    ),
            },
        ],
        [filterData]
    );

    return (
        <Fragment>
            <PageHeading/>

            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="12" lg="12">
                            <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    <ReactTableGeneric
                                        columns={columns}
                                        data={data}
                                        tableClassName="mb-0 table table-borderless table-sm table-hover icon-center"
                                        count={totalCount}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>
            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">                 
                        <CustomFilter data={dropdownData} handleCallback={handleSelect} />
                </CardFooter>


            </div>
        </Fragment>
    );
};

export default Actueel;
